export default {
    'add-new-salary': ' إضافة راتب جديد لموظف',
    'use-excel-file': 'استخدم ملف اكسل',
    'rebates': 'الخصومات',
    'salary-is-added': 'تم إضافة الراتب',
    'salary-is-edited': 'تم تعديل الراتب'
}